/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Fragment } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Colors } from "../../../conventions/constants"
import Row from "./row";

import { useMediaQuery, useTheme } from '@mui/material';

const LookupTable = ({ rows, removeRow, removeAllRows }) => {

const hasNoContent = () => !rows || !rows.length;

  const theme = useTheme();
  const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const isXsDown = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Fragment>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>

            <TableRow>

              {!isXlUp && (
                <TableCell />
              )}
              
              <TableCell align="center">SERIAL NUMBER</TableCell>

              {!isSmDown && (
                <TableCell align="center">VERSION</TableCell>
              )}

              {!isLgDown && (
                <TableCell align="center">OEM</TableCell>
              )}

              {!isLgDown && (
                <TableCell align="center">TYPE</TableCell>
              )}

              {!isMdDown && (
                <TableCell align="center">VOLTAGE</TableCell>
              )}

              {!isMdDown && (
                <TableCell align="center">BOUDRATE</TableCell>
              )}
              
              {!isXsDown && (
                <TableCell align="center">REMOTE DOWNLOAD</TableCell>
              )}

              <TableCell align="center" css={css`&:hover{text-decoration:underline;color:${Colors.TeltonikaBlue}}cursor:pointer`} title="remove all rows" onClick={removeAllRows}>CLEAR</TableCell>              
              
            </TableRow>

          </TableHead>

          <TableBody>
            {rows.map((row) => (<Row key={row.serialNumber} row={row} removeRow={removeRow} />))}
          </TableBody>
        
        </Table>
      
      </TableContainer>
      
      <div css={css`text-align:center;padding:20px;color:#888;${hasNoContent() ? "" : "display:none"}`}>List is empty</div>
    
    </Fragment>
  );
};

export default LookupTable;